import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function Preloader() {
  const { pathname } = useLocation();
  const firstVisit = typeof window !== "undefined" && !sessionStorage.getItem("ambrai_loaded");
  const shouldShow = pathname === "/" && firstVisit;

  const [exiting, setExiting] = useState(false);
  const [gone, setGone] = useState(!shouldShow);

  useEffect(() => {
    if (!shouldShow) return;
    sessionStorage.setItem("ambrai_loaded", "1");
    const t1 = setTimeout(() => setExiting(true), 1700);
    const t2 = setTimeout(() => setGone(true), 2500);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [shouldShow]);

  if (gone) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-ink text-ivory"
      style={{
        transform: exiting ? "translateY(-100%)" : "translateY(0)",
        transition: "transform 0.8s cubic-bezier(0.76,0,0.24,1)",
      }}
      data-testid="preloader"
    >
      <div className="overflow-hidden">
        <img
          src="/ambrai-logo.png"
          alt="Amraiya"
          className="preloader-word h-40 md:h-64 w-auto"
          style={{ filter: "invert(1) brightness(2)" }}
        />
      </div>
      <div className="overline mt-6 text-gold preloader-sub">Couture &amp; Heritage</div>
      <div className="absolute bottom-10 left-0 right-0 mx-auto h-px w-40 overflow-hidden bg-white/20">
        <div className="preloader-bar h-full bg-gold" />
      </div>
    </div>
  );
}
